import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BRAND } from "@/lib/brand";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#1A1A1A] text-[#666666]"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12 pt-20 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-4">
                            <img
                                src={BRAND.logoMonogramGoldOnWhite}
                                alt="Aurum Vanguard"
                                className="h-12 w-12 object-contain"
                            />
                            <span className="font-serif-display text-2xl text-[#F4F1EA] tracking-tight">
                                Aurum Vanguard
                            </span>
                        </div>
                        <p className="mt-5 text-sm text-[#A4A19A] max-w-xs leading-relaxed">
                            {t("footer.tagline")}
                            <br />
                            {t("footer.city")}
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <p className="overline mb-5">{t("footer.company")}</p>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href="/#equipo"
                                    data-testid="footer-link-equipo"
                                    className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors"
                                >
                                    {t("footer.who_we_are")}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#metodo"
                                    data-testid="footer-link-metodo"
                                    className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors"
                                >
                                    {t("footer.method")}
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/contacto"
                                    data-testid="footer-link-contacto"
                                    className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors"
                                >
                                    {t("footer.contact_link")}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="overline mb-5">{t("footer.sectors")}</p>
                        <ul className="space-y-3 text-sm">
                            <li><a href="/#sectores" className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors">Inmobiliario</a></li>
                            <li><a href="/#sectores" className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors">Servicios profesionales</a></li>
                            <li><a href="/#sectores" className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors">Salud y bienestar prime</a></li>
                            <li><a href="/#sectores" className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors">Financiero e intermediación</a></li>
                            <li><a href="/#sectores" className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors">Hospitality, eventos y restauración prime</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <p className="overline mb-5">{t("footer.contact")}</p>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={`mailto:${BRAND.contact.email}`}
                                    data-testid="footer-email"
                                    className="text-[#A4A19A] hover:text-[#8B6914] hover:underline transition-colors break-all"
                                >
                                    {BRAND.contact.email}
                                </a>
                            </li>
                            <li className="text-[#A4A19A]">{BRAND.contact.location}</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-xs text-[#666666]">
                    <p data-testid="footer-copy">{t("footer.copy", { year })}</p>
                    <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                        <LanguageSwitcher />
                        <div className="flex gap-6">
                            <Link to="/legal" data-testid="footer-link-legal" className="hover:text-[#8B6914] hover:underline">{t("footer.legal_notice")}</Link>
                            <Link to="/privacidad" data-testid="footer-link-privacidad" className="hover:text-[#8B6914] hover:underline">{t("footer.privacy")}</Link>
                            <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-[#8B6914] hover:underline">{t("footer.cookies")}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
